import dashboardRoutes from './dashboard.routes'
import comprasRoutes from './compras.routes'
import productosRoutes from './productos.routes'
import sucursalesRoutes from './sucursales.routes'
import ventasRoutes from './ventas.routes'
import produccionRoutes from './produccion.routes'
import contabilidad from './contabilidad.routes.js'
import marcasRoutes from './marcas.routes.js'
import proveedoresRoutes from './proveedores.routes.js'
import reportes from './reportes.routes'
import empleadosRoutes from './empleados.routes.js'
import clientesRoutes from './clientes.routes.js'
import integracionesRoutes from './integraciones.routes.js'
import sueldosRoutes from './sueldos.routes.js'
import suscripcionRoutes from './suscripcion.routes.js'


export default [
  ...dashboardRoutes,
  ...comprasRoutes,
  ...productosRoutes,
  ...ventasRoutes,
  ...produccionRoutes,
  ...marcasRoutes,
  ...proveedoresRoutes,
  ...contabilidad,
  ...reportes,
  ...empleadosRoutes,
  ...clientesRoutes,
  ...integracionesRoutes,
  ...sueldosRoutes,
  ...suscripcionRoutes,

  // Las rutas de sucursales deben ir al final para que no se sobreescriban las rutas de empresa
  // ya que las rutas de sucursales son más específicas y deben tener prioridad
  ...sucursalesRoutes,
]
